import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const phoneNumber = "919910317286";
  const message = "Hello, I would like to book an appointment with Dr. Sanjay Sachdeva.";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-24 md:bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-green-500 text-white flex items-center justify-center shadow-lg hover:bg-green-600 transition-all hover:scale-110"
      data-testid="whatsapp-btn"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-7 h-7" />
    </a>
  );
}
